export default __webpack_public_path__ + "static/media/3.260be072.png";